// Import utilities
const {
	isEmpty
} = _uo.utility;

/**
 * Checks whether the recipe has conditions
 *
 * @return {Boolean} True if the recipe has conditions
 */
const recipeHasConditions = () => {
	return ! isEmpty( UncannyAutomator.recipe.conditions );
};

export default recipeHasConditions;
